"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Analytics = void 0;

var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isValidString = function isValidString(string) {
  return Boolean(string && string.trim && string.trim());
};

var validateRequiredAndCamel = function validateRequiredAndCamel(value, name) {
  if (!isValidString(value) || value[0] !== value[0].toUpperCase()) {
    throw new Error("".concat(name, " is required and has to be in CamelCase format."));
  }

  return value;
};

var validateIsOneOf = function validateIsOneOf(value, name, values) {
  if (values.indexOf(value) === -1) {
    throw new Error("".concat(name, " should be one of: \"").concat(values.join('", "'), "\""));
  }

  return value;
};

var validateProperty = function validateProperty(property, name) {
  if (!isValidString(property.type)) {
    throw new Error("".concat(name, ".type is required."));
  }

  if (property.value == null) {
    throw new Error("".concat(name, ".value is required."));
  }

  validateIsOneOf(property.type, "".concat(name, ".type"), ['label', 'metric', 'dimension']);
  return property;
};

var mapProperties = function mapProperties(properties) {
  if ((0, _isPlainObject.default)(properties)) {
    Object.keys(properties).forEach(function (name) {
      return validateProperty(properties[name], name);
    });
  } else if (properties) {
    throw new Error('Properties must be a plain object.');
  }

  var _groupBy = (0, _groupBy2.default)((0, _mapValues.default)(properties, function (obj, key) {
    return _objectSpread({
      name: key
    }, obj);
  }), 'type'),
      dimension = _groupBy.dimension,
      label = _groupBy.label,
      metric = _groupBy.metric;

  var attributes = {};

  if (dimension) {
    attributes.dimensions = dimension.reduce(function (dimensions, dimension) {
      // eslint-disable-next-line no-param-reassign
      dimensions[dimension.name] = dimension.value;
      return dimensions;
    }, {});
  }

  if (metric) {
    attributes.metrics = metric.reduce(function (metrics, metric) {
      // eslint-disable-next-line no-param-reassign
      metrics[metric.name] = metric.value;
      return metrics;
    }, {});
  }

  if (label) {
    if (label.length > 1) {
      throw new Error('Can only have 1 property of type "label"');
    }

    attributes.label = label[0].value;
  }

  return attributes;
};
/**
 * The Analytics Model Schema helper is a function that allows to define
 * GA actions following EB's Object+Action+properties conventions.
 */


var Analytics = {
  /**
   * Analytics.event()
   * Use to define a GA event by providing the object action and properties
   * following EB's Object+Action convention. Defined on:
   * https://docs.google.com/spreadsheets/d/1L8EDa1_i8iZyC6g_0ElvTXCoPiKfELTgl06qtbrJc-g/edit#gid=745728795
   *
   * IMPORTANT: This function does NOT perform the tracking, it's a utility to map
   * the Analytics model into a dispatchable GA custom event declaration.
   * You can pass what this function returns to any of our tracking functions like
   * the analytics redux middleware or trackAnalyticsEvent().
   *
   * @param {String} params.object The Object being tracked (Required)
   * @param {String} params.action The Action performed on the Object (Required)
   * @param {String} params.properties A map of property definitions to track
   * @param {String} params.properties[prop].type How this property is going to be tracked: "label", "dimension" or "metric". (Required if property defined)
   * @param {String} params.properties[prop].value The value to track for this property. (Required if property defined)
   */
  event: function event(_ref) {
    var object = _ref.object,
        action = _ref.action,
        properties = _ref.properties;
    return _objectSpread({
      action: "".concat(validateRequiredAndCamel(object, 'object')).concat(validateRequiredAndCamel(action, 'action'))
    }, mapProperties(properties));
  }
};
exports.Analytics = Analytics;
//# sourceMappingURL=analyticsModelSchema.js.map